/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Booking_UpsInputs */

const en_orders_booking_ups = /** @type {(inputs: Orders_Booking_UpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking UPS...`)
};

const es_orders_booking_ups = /** @type {(inputs: Orders_Booking_UpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservando UPS...`)
};

/**
* | output |
* | --- |
* | "Booking UPS..." |
*
* @param {Orders_Booking_UpsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_booking_ups = /** @type {((inputs?: Orders_Booking_UpsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Booking_UpsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_booking_ups(inputs)
	return es_orders_booking_ups(inputs)
});